import { Component, OnInit } from '@angular/core';
import { SystemService } from 'src/app/services/system.service';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { MessageService, Message, ConfirmationService } from 'primeng/api';
import { CookieService } from 'ngx-cookie-service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { mergeMap, catchError } from 'rxjs/operators';
import {Observable, of} from "rxjs";


@Component({
  templateUrl: './assessor-dict.component.html'
})
export class AssessorDictComponent implements OnInit {
  dictTypeList: any[];
  dictType = '';
  crewList: [];
  divisionList: [];
  specialCaseList: [];
  myEntry: any;

  isNewEntry = false;

  displayState: any = {
    workingDiv: false,
    dictDiv: true,
    crewDiv: false,
    divisionDiv: false,
    specialCaseDiv: false,
    crewEntryDiv: false,
    divisionEntryDiv: false,
    specialCaseEntryDiv: false,
    saveDisabled: false
  };

  activeUserOnly = true;

  constructor(private systemService: SystemService, private messageService: MessageService,
              private confirmationService: ConfirmationService,
              private dictionaryService: DictionaryService, private utilService: UtilitiesService,
              private cookieService: CookieService) { }

  ngOnInit() {
    this.dictTypeList = [
      { id: 'crew', desc: 'Crew'},
      { id: 'division', desc: 'Division'},
      { id: 'specialcase', desc: 'Special Case Type'}
    ];
    this.loadAllDictionaries();
  }
  // get all the dictionaries using (daisy) chained observables
  loadAllDictionaries() {
    this.getCrewDict()
      .pipe(
        mergeMap((resultA) => {
          // console.log(resultA);
          this.utilService.doAudit(resultA, 'resultA:');
          this.crewList = resultA;
          return this.getDivisionDict(); // Executes concurrently
        }),
        mergeMap((resultB) => {
          // console.log(resultB);
          this.utilService.doAudit(resultB, 'resultB:');
          this.divisionList = resultB;
          return this.getSpecialCaseDictionaries(); // Executes concurrently
        }),
        catchError((error) => {
          this.utilService.doAudit('Could not load all the dictionaries!', 'Error:');
          return of('Error handled');
        })
      )
      .subscribe((finalResult) => {
        this.utilService.doAudit(finalResult, 'final result:');
        this.specialCaseList = finalResult;
      });
  }

  getCrewDict(): Observable<any> {
    return this.dictionaryService.getCaseDictionaries('crew');
  }
  getDivisionDict(): Observable<any> {
    return this.dictionaryService.getCaseDictionaries('division');
  }
  getSpecialCaseDictionaries(): Observable<any> {
    return this.dictionaryService.getCaseDictionaries('specialcase');
  }

  loadDictionary(dictType: string) {
    this.displayState.workingDiv = true;
    dictType = dictType.toLowerCase();
    this.dictionaryService.getCaseDictionaries(dictType).subscribe (data => {
      this.displayState.workingDiv = false;
      this.utilService.doAudit(data, 'got dictionary: ' + dictType);
      if (data) {
        if (dictType == 'crew') {
          this.crewList = data;
        } else if (dictType == 'division') {
          this.divisionList = data;
        } else if (dictType == 'specialcase') {
          this.specialCaseList = data;
        }
      }
    });
  }

  onChangeType() {
    this.hideDivs(true);  // hide all dict-specific divs + main (dictionary type) div...
    const dt = this.dictType.toLowerCase();
    this.utilService.doAudit(dt, 'selected type:');
    if (dt == '') { return; }
    if (dt == 'crew') {
      this.displayState.crewDiv = true;
    } else if (dt == 'division') {
      this.displayState.divisionDiv = true;
    } else if (dt == 'specialcase') {
      this.displayState.specialCaseDiv = true;
    } else {
      alert('Unknown dictionary!');
      this.cancelEntry(false); // to display the dictionary div!
    }
    this.myEntry = null;
    return;
  }
  onSelect(item: any) {
    this.hideDivs(true);
    this.myEntry = item;
    this.showDiv();
  }
  newCrew() {
    // create new crew
    this.isNewEntry = true;
    this.myEntry = { id: 0, crew: ''};
    this.showDiv();
  }
  deleteCrew(item: any) {
    this.loadDictionary('crew');
  }

  newDivision() {
    // create new division
    this.isNewEntry = true;
    this.myEntry = { id: 0, division: ''};
    this.showDiv();
  }
  deleteDivision(item: any) {
    // refresh list
    this.loadDictionary('division');
    this.cancelEntry();
  }

  newSpecialCase() {
    // create new special case
    this.isNewEntry = true;
    this.myEntry = { id: 0, specialcase: ''};
    this.showDiv();
  }

  deleteSpecialCase(item: any){
    // refresh list
    this.loadDictionary('specialcase');
    this.cancelEntry();
  }

  saveEntry() {
    const dictType = this.dictType;
    if (this.validateDictData(dictType) === false ) {
      this.showToast({severity: 'error', summary: '', detail: 'Required items are missing.'});
      return true;
    }
    this.displayState.saveDisabled = true;  // so they can't click on the Save button again...
    this.dictionaryService.saveCaseDictionaries(dictType, this.myEntry).subscribe(data => {
      if (data) {
        this.showToast({ severity: 'Info', summary: '', detail: 'Item saved'});
      }
      // refresh list
      // this.loadDictionary(dictType);
      this.cancelEntry(true); // hides divs, returns to parent div...
      return true;
    });
  }
  deleteEntry(item:any) {
    const dictType = this.dictType;
    this.utilService.doAudit(item, 'delete ' + dictType + ':');
    this.confirmationService.confirm({
      message: 'Do you want to DELETE this item?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.dictionaryService.deleteCaseDictionaries(dictType, item.id).subscribe(data => {
          if (data) {
            this.showToast({severity: 'Info', summary: '', detail: 'Item DELETED'});
          }
          this.cancelEntry(true); // hides divs, reload list, return to parent div...
        });
      },
      reject: () => {
        this.showToast({severity: 'info', detail: 'No action performed.', summary: ''});
      }
    });
    return true;
  }
  validateDictData(dictType: string): boolean {
    const myItem = this.myEntry;
    if (dictType == 'crew') {
      return myItem.crew != '';
    } else if (dictType == 'division') {
      return myItem.division != '';
    } else if (dictType == 'specialcase') {
      return myItem.specialCase != '';
    } else { return false; }  // just in case...
  }

  cancelEntry(reloadList: boolean = true) {
    this.hideDivs();
    this.isNewEntry = false;
    this.myEntry = null;
    if (reloadList) {
      this.loadDictionary(this.dictType);
    }
    this.displayState.dictDiv = true;
    this.showParentDiv();
    return true;
  }

  hideDivs(inclMain: boolean = false) {
    this.displayState.crewDiv = false;
    this.displayState.divisionDiv = false;
    this.displayState.specialCaseDiv = false;
    this.displayState.crewEntryDiv = false;
    this.displayState.divisionEntryDiv = false;
    this.displayState.specialCaseEntryDiv = false;
    if (inclMain) {
      // hide the Main (dictionary) div, too!
      this.displayState.dictDiv = false;
    }
    this.displayState.workingDiv = false; // just in case...
  }
  showDiv() {
    const dt = this.dictType.toLowerCase();
    this.utilService.doAudit(dt,'showing edit div for type: ' + dt);
    if (dt == 'crew') {
      // this.displayState.crewDiv = true;
      this.displayState.crewEntryDiv = true;
    } else if (dt == 'division') {
      // this.displayState.divisionDiv = true;
      this.displayState.divisionEntryDiv = true;
    } else if (dt == 'specialcase') {
      // this.displayState.specialCaseDiv = true;
      this.displayState.specialCaseEntryDiv = true;
    } else {
      alert('Unknown dictionary!');
    }
  }

  showParentDiv() {
    const dt = this.dictType.toLowerCase();
    if (dt == 'crew') {
      this.displayState.crewDiv = true;
    } else if (dt == 'division') {
      this.displayState.divisionDiv = true;
    } else if (dt == 'specialcase') {
      this.displayState.specialCaseDiv = true;
    } else {
      // alert('Unknown dictionary!');
    }

  }

  showToast(msg: Message) {
    this.messageService.add(msg);
  }

  clear() {
    this.messageService.clear();
  }
}
